var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      attrs: {
        drawer: _vm.drawer,
        title: "跟进记录",
        withHeader: false,
        size: 740,
      },
      on: { close: _vm.close },
    },
    [
      _c("div", { staticClass: "view" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "title_left" }, [
            _c("div", { staticClass: "title-main" }, [
              _c("img", {
                attrs: { src: require("@/assets/images/bill/record-1.png") },
              }),
              _vm._v("跟进记录 "),
            ]),
            _c("div", { staticClass: "copy-no" }, [
              _c("span", [_vm._v("提单号：" + _vm._s(_vm.rowData.blNo))]),
              _c("img", {
                attrs: {
                  src: require("@/assets/images/bill/copy.png"),
                  title: "复制",
                },
                on: {
                  click: function ($event) {
                    return _vm.copy(_vm.rowData.blNo)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "main" }, [
            _c(
              "div",
              {
                staticClass: "main-contanier",
                style: {
                  height: _vm.terminologyType.isEnable
                    ? "calc(100% - 284px)"
                    : "calc(100% - 174px)",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "baseData" },
                  [
                    _c("base-table", {
                      attrs: {
                        height: 600,
                        tableData: _vm.tableData,
                        isEmptyBorder: true,
                        isPager: false,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "description",
                          fn: function (row) {
                            return [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(row.scope.description),
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "add" }, [
              _c(
                "div",
                { staticClass: "type" },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择跟进记录类型" },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.terminologyId,
                        callback: function ($$v) {
                          _vm.terminologyId = $$v
                        },
                        expression: "terminologyId",
                      },
                    },
                    _vm._l(_vm.remarkTypeOptions, function (item, $index) {
                      return _c("el-option", {
                        key: $index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                  _vm.terminologyType.isEnable
                    ? _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: 500,
                          rows: 5,
                          resize: "none",
                          placeholder: "请输入其他跟进内容，最多输入500字",
                        },
                        model: {
                          value: _vm.description,
                          callback: function ($$v) {
                            _vm.description = $$v
                          },
                          expression: "description",
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "submit" }, [
                    _c("div", { staticClass: "btn", on: { click: _vm.send } }, [
                      _vm._v("添加"),
                    ]),
                    _vm.terminologyType.isEnable
                      ? _c("span", [_vm._v("按下enter换行")])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }